import { useEffect, useState } from 'react'
import VinSearch from '@/components/landing/vinSearch'
import VehicleSelector from '@/components/themes/subaru/landing/vehicleSelector'
import { configSelectors } from '@/store/configs'
import { i18nL10nSelectors } from '@/store/i18nL10n'
import { productSelectors } from '@/store/products'
import { useSelector } from 'react-redux'
import { ContentContainer } from '@/components/styles'
import { Grid } from 'rsuite'
import { customerHelper, i18nConstants } from '@tweddle-se-team/common/constants'
import pubhubData from '@/utils/apiHelpers/pubhubData'

const { rtlLanguagesISO2Codes } = i18nConstants
const { CUSTOMER_IDS } = customerHelper

const loadProductImagesByCustomer = {
  [CUSTOMER_IDS.SUBARU]: async () => [],
  [CUSTOMER_IDS.NORDICS]: () => pubhubData.getProductsImages()
}

const Content = () => {
  const products = useSelector(productSelectors.selectProducts)
  const i18nL10n = useSelector(i18nL10nSelectors.selectI18nL10n)
  const modelLangMarketingNames = useSelector(configSelectors.selectConfigByKey('modelLangMarketingNames'))
  const customerId = useSelector(configSelectors.selectCustomerId)
  const [productImages, setProductImages] = useState([])
  const { locale } = i18nL10n
  const rightAlign = Array.isArray(rtlLanguagesISO2Codes) && locale ? rtlLanguagesISO2Codes.includes(locale) : false

  useEffect(() => {
    let isMounted = true
    const loadProductImages =
      loadProductImagesByCustomer[customerId] || loadProductImagesByCustomer[CUSTOMER_IDS.SUBARU]

    loadProductImages()
      .then(images => {
        if (isMounted) setProductImages(images || [])
      })
      .catch(() => {
        if (isMounted) setProductImages([])
      })

    return () => {
      isMounted = false
    }
  }, [customerId])

  return (
    <div>
      <ContentContainer $rightAlign={rightAlign}>
        <Grid fluid>
          <VinSearch i18nL10n={i18nL10n} products={products} />
          <VehicleSelector
            i18nL10n={i18nL10n}
            products={products}
            modelLangMarketingNames={modelLangMarketingNames}
            productImages={productImages}
          />
          <div className="mb-30" />
        </Grid>
      </ContentContainer>
    </div>
  )
}

export default Content
